import React from 'react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import HeroSection from '../components/landing/HeroSection';
import PillarsSection from '../components/landing/PillarsSection';
import ActivitiesSection from '../components/landing/ActivitiesSection';
import InterviewSection from '../components/landing/InterviewSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import TPICertificationSection from '../components/landing/TPICertificationSection';
import OrganizationsSection from '../components/landing/OrganizationsSection';
import PricingSection from '../components/landing/PricingSection';
import CTASection from '../components/landing/CTASection';

/**
 * Home page narrative:
 *   hero        - the promise, evidenced by a real score card
 *   pillars     - the three things you get
 *   modules     - the breadth (11 modules)
 *   interview   - the standout feature, on a dark stage
 *   how it works- why the score is earned, not given
 *   TPI         - what the score actually measures
 *   orgs        - the second audience (colleges & employers)
 *   pricing     - the ask
 *   CTA         - the close
 * Sections alternate white / off-white so the eye gets a rhythm.
 */
const HomePage = () => (
  <div className="min-h-screen">
    <Header />
    <main>
      <HeroSection />
      <PillarsSection />
      <ActivitiesSection />
      <InterviewSection />
      <HowItWorksSection />
      <TPICertificationSection />
      <OrganizationsSection />
      <PricingSection />
      <CTASection />
    </main>
    <Footer />
  </div>
);

export default HomePage;
